import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import bgHomeS6 from "../../assets/landingPage/bg-home-s6.png";

const overviewItems = [
  {
    id: "01",
    title: "Streaming Hub",
    description: "Watch, listen, and experience content across every genre.",
    imageUrl: "https://plus.unsplash.com/premium_photo-1678112183791-498b49242d1c?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    path: "/ProductCollection",
    buttonText: "Explore Streaming Hub",
    isExternal: false,
  },
  {
    id: "02",
    title: "Digital Publishing",
    description: "Ebooks, audiobooks, songs, scripts and manuscripts - all in one place.",
    imageUrl: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?auto=format&fit=crop&q=80&w=300&h=200",
    path: "/digital-library",
    buttonText: "Visit Digital Library",
    isExternal: false,
  },
  {
    id: "03",
    title: "Exclusive Content",
    description: "Premium releases available only on BAB Media.",
    imageUrl: "https://plus.unsplash.com/premium_photo-1688561383440-feef3fee567d?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    path: "/news-new",
    buttonText: "View Exclusives",
    isExternal: false,
  },
  {
    id: "04",
    title: "Creator Marketplace",
    description: "Sell, stream, and distribute your work globally.",
    imageUrl: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=300&h=200",
    path: "https://admin.bab-media.com/public/login",
    buttonText: "Become A Seller",
    isExternal: true,
  },
];

export default function OverviewSectionNew() {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  const handleNavigation = (path, isExternal) => {
    if (isExternal) {
      window.open(path, "_blank", "noopener,noreferrer");
    } else {
      navigate(path);
    }
  };

  return (
    <section
      id="overview"
      className="w-full py-20 px-4 md:px-8 lg:px-16  bg-cover bg-center relative animate-fade-in"
      style={{ backgroundImage: `url(${bgHomeS6})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 pointer-events-none"></div>

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center">
        {/* Title */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-oswald text-white tracking-widest uppercase mb-12 text-center">
          DIGITAL MEDIA OVERVIEW
        </h2>

        {/* Accordion List Container */}
        <div className="w-full flex flex-col gap-4 select-none">
          {overviewItems.map((item, idx) => {
            const isActive = activeIndex === idx;
            return (
              <div
                key={item.id}
                onClick={() => setActiveIndex(idx)}
                className={`w-full flex flex-col md:flex-row items-center md:justify-between py-6 px-8 rounded-2xl cursor-pointer transition-all duration-500 overflow-hidden ${isActive
                  ? "bg-white text-neutral-900 shadow-2xl scale-[1.01]"
                  : "bg-neutral-950/45 border border-neutral-900/60 hover:bg-neutral-900/40 text-white"
                  }`}
              >
                {/* Left Panel Content */}
                <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 text-center sm:text-left flex-1">
                  {/* Number Badge */}
                  <span
                    className={`font-oswald text-2xl font-bold transition-colors ${isActive ? "text-secondary" : "text-gray-500"
                      }`}
                  >
                    {item.id}
                  </span>

                  {/* Title and Description */}
                  <div className="flex-1 flex flex-col items-center sm:items-start">
                    <h3 className={`text-xl md:text-2xl font-bold font-oswald tracking-wide ${isActive ? "text-secondary" : "text-white"} mb-1 uppercase`}>
                      {item.title}
                    </h3>
                    <p
                      className={`text-sm font-outfit max-w-md transition-colors ${isActive ? "text-gray-800" : "text-gray-400"
                        } mb-2`}
                    >
                      {item.description}
                    </p>

                    {/* Expandable Action Button */}
                    <div
                      className={`transition-all duration-500 overflow-hidden ${isActive ? "max-h-16 opacity-100 mt-2" : "max-h-0 opacity-0 pointer-events-none"}`}
                    >
                      <button
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent toggling accordion again
                          handleNavigation(item.path, item.isExternal);
                        }}
                        className="px-5 py-2 bg-[#FF8C21] hover:bg-neutral-950 text-black hover:text-white font-bold font-outfit text-xs md:text-sm rounded-lg transition-all duration-300 uppercase tracking-widest flex items-center gap-1.5 shadow-md active:scale-95"
                      >
                        {item.buttonText}
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Right Panel Content (Image and Action Button) */}
                <div className="flex items-center gap-6 mt-6 md:mt-0 w-full md:w-auto justify-center md:justify-end">
                  {/* Expanded image */}
                  <div
                    className={`relative rounded-xl overflow-hidden shadow-md transition-all duration-500 origin-right ${isActive
                      ? "w-36 h-20 opacity-100 scale-100"
                      : "w-0 opacity-0 scale-95 pointer-events-none"
                      }`}
                  >
                    <img
                      src={item.imageUrl}
                      alt={item.title}
                      className="object-cover w-full h-full"
                    />
                  </div>

                  {/* Circular Arrow Button */}
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNavigation(item.path, item.isExternal);
                    }}
                    className={`w-12 h-12 rounded-full flex items-center justify-center border transition-all duration-300 ${isActive
                      ? "border-black bg-transparent text-black hover:bg-secondary hover:text-white"
                      : "border-neutral-700 bg-transparent text-neutral-400 hover:border-secondary hover:text-secondary"
                      }`}
                  >
                    <svg
                      className="w-5 h-5 transform rotate-45"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                    </svg>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
